
export const heTranslations = {
  home: "בית",
  about: "אודות",
  services: "שירותים",
  blog: "בלוג",
  contact: "צור קשר",
  bookAppointment: "לקבוע פגישה",
  appointment: "פגישה",
  patientStories: "סיפורי מטופלים",
  videoTestimonials: "וידאו המלצות",
  videoTestimonialsDescription: "צפו בסיפורי המטופלים שלנו ושמעו ממקור ראשון על החוויה שלהם.",
  allStories: "כל הסיפורים",
  breastCancer: "סרטן השד",
  lungCancer: "סרטן הריאות",
  gastrointestinal: "גסטרואינטסטינלי",
  lymphoma: "לימפומה",
  noStoriesFound: "לא נמצאו סיפורים בקטגוריה זו.",
  rights: "כל הזכויות שמורות",
  learnMore: "למידע נוסף",
  readMore: "קרא עוד",
  name: "שם",
  email: "דוא\"ל",
  phone: "טלפון",
  date: "תאריך",
  time: "זמן",
  reason: "סיבה",
  message: "הודעה",
  submit: "שלח",
  successAppointment: "הפגישה נקבעה בהצלחה!",
  fillAllFields: "אנא מלא את כל השדות.",
  aboutUs: "עלינו",
  ourDoctors: "הרופאים שלנו",
  ourServices: "השירותים שלנו",
  contactUs: "צור קשר",
  address: "כתובת",
  openingHours: "שעות פתיחה",
  mondayFriday: "יום שני-שישי",
  saturday: "שבת",
  sunday: "יום ראשון",
  closed: "סגור",
  emailUs: "שלח לנו אימייל",
  callUs: "התקשר אלינו",
  ourLocation: "המיקום שלנו",
  treatment: "טיפול",
  diagnosis: "אבחון",
  research: "מחקר",
  wellness: "בריאות",
  latestNews: "החדשות האחרונות",
  allNews: "כל החדשות",
  noNewsFound: "לא נמצאו חדשות.",
  ourTestimonials: "ההמלצות שלנו",
  excellent: "מְצוּיָן",
  veryGood: "טוב מאוד",
  good: "טוב",
  fair: "הוגן",
  poor: "עני",
  noTestimonialsFound: "לא נמצאו המלצות.",
  ourTeam: "הצוות שלנו",
  ourValues: "הערכים שלנו",
  ourMission: "המשימה שלנו",
  whyChooseUs: "למה לבחור בנו?",
  yearsOfExperience: "שנות ניסיון",
  happyPatients: "מטופלים מרוצים",
  awardsWon: "פרסים שזכו",
  doctorsAvailable: "רופאים זמינים",
  comprehensiveCare: "טיפול מקיף",
  personalizedTreatmentPlans: "תוכניות טיפול מותאמות אישית",
  advancedTechnology: "טכנולוגיה מתקדמת",
  backToVideos: "חזרה לסרטונים",
  noVideosFound: "לא נמצאו וידאו עדויות",
  
  // FAQ section
  frequentlyAskedQuestions: "שאלות נפוצות",
  faqSubtitle: "מצא תשובות לשאלות נפוצות על השירותים האונקולוגיים שלנו",
  dontSeeQuestion: "לא רואה את השאלה שלך כאן? אל תהסס לפנות אלינו ישירות.",
  
  // Admin section
  messages: "הודעות",
  messagesManagement: "ניהול הודעות",
  recentMessages: "הודעות אחרונות",
  messageDetails: "פרטי הודעה",
  allMessages: "כל ההודעות",
  noMessages: "לא נמצאו הודעות",
  markAsRead: "סמן כנקרא",
  markAsUnread: "סמן כלא נקרא",
  messageFrom: "הודעה מאת",
  sent: "נשלח",
  reply: "השב",
  deleteMessage: "מחק הודעה",
  faqsManagement: "ניהול שאלות נפוצות",
  addFaq: "הוסף שאלה נפוצה",
  editFaq: "ערוך שאלה נפוצה",
  question: "שאלה",
  answer: "תשובה",
  contentManagement: "ניהול תוכן",
  footerManagement: "ניהול כותרת תחתונה",
  contactInfoManagement: "ניהול פרטי יצירת קשר",
  biographyManagement: "ניהול ביוגרפיה",
  editContent: "ערוך תוכן",
  save: "שמור",
  cancel: "ביטול",
  contentUpdated: "התוכן עודכן בהצלחה",
  contentCreated: "התוכן נוצר בהצלחה",
  contentDeleted: "התוכן נמחק בהצלחה",
  confirmDelete: "האם אתה בטוח שברצונך למחוק פריט זה?",
  addNew: "הוסף חדש",
  emptyState: "לא נמצאו פריטים. לחץ על 'הוסף חדש' כדי ליצור אחד.",
  
  // FAQ questions and answers
  faqCancerTypes: "באילו סוגי סרטן ד״ר נימן מתמחה?",
  faqCancerTypesAnswer: "ד״ר נימן מתמחה בטיפול במגוון רחב של סוגי סרטן, עם מומחיות מיוחדת בסרטן השד, סרטן הריאות, סרטן במערכת העיכול ולימפומות.",
  faqTreatmentTime: "כמה זמן נמשך תהליך טיפול טיפוסי?",
  faqTreatmentTimeAnswer: "משך הטיפול בסרטן משתנה משמעותית בהתאם לסוג ושלב הסרטן, וכן לגישת הטיפול הספציפית. במהלך הייעוץ, ד״ר ניימן תספק לך לוח זמנים מפורט על בסיס המקרה האישי שלך.",
  faqTeam: "האם ד״ר ניימן עובדת עם צוות רב-תחומי?",
  faqTeamAnswer: "כן, ד״ר ניימן משתפת פעולה עם צוות מקיף של אנשי מקצוע בתחום הבריאות כולל מנתחים, אונקולוגים מומחי קרינה, פתולוגים, אחיות, תזונאים ואנשי מקצוע בתחום בריאות הנפש כדי להבטיח טיפול הוליסטי לכל מטופל.",
  faqFirstAppointment: "מה עלי להביא לפגישה הראשונה שלי?",
  faqFirstAppointmentAnswer: "אנא הבא את הרשומות הרפואיות שלך, כולל תוצאות בדיקות קודמות, סריקות ודוחות פתולוגיים. כמו כן, הבא רשימה של תרופות נוכחיות, מידע על ביטוח וכל שאלה שיש לך.",
  faqTelemedicine: "האם זמינות התייעצויות רפואה מרחוק?",
  faqTelemedicineAnswer: "כן, ד״ר ניימן מציעה פגישות רפואה מרחוק למצבים מתאימים כגון ייעוץ המשך וסוגים מסוימים של דיוני טיפול.",
  
  // Quick links section
  quickLinks: "קישורים מהירים",
  contactInfo: "פרטי יצירת קשר",
  officeHoursFooter: "שעות פעילות",
  privacyPolicy: "מדיניות פרטיות",
  termsOfService: "תנאי שימוש",
  
  // Navbar
  
  // Hero Section
  heroTitle: "טיפול אונקולוגי מיוחד עם ד\"ר ויקטוריה ניימן",
  heroSubtitle:
    "אונקולוגית מובילה המחויבת לספק טיפול אישי בסרטן באמצעות מומחיות רפואית חדשנית וטיפול חומל.",
  
  // About Section
  aboutSectionTitle: "ד\"ר ויקטוריה ניימן",
  aboutSectionSubtitle: "רופאה בכירה ומוערכת המתמחה באונקולוגיה קלינית וטיפול מותאם אישית בסרטן",
  aboutSectionText1: "ד\"ר ויקטוריה ניימן היא מומחית מובילה באונקולוגיה קלינית, רפואה פנימית ורדיותרפיה, עם ניסיון של למעלה מ-30 שנה. היא מנהלת את מחלקת האשפוז האונקולוגי במרכז דוידוף לסרטן שבמרכז הרפואי רבין.",
  aboutSectionText2: "התמחותה מתמקדת בגידולים אורו-אונקולוגיים, כולל סרטן כליה, ערמונית, שלפוחית השתן ואשכים, וכן בסרטן השד. ד\"ר ניימן פעילה במחקרים קליניים בינלאומיים, מרצה באוניברסיטת תל אביב ומובילה חידושים בתחום האונקולוגיה.",
  aboutSectionText3: "היא ידועה בגישתה האנושית והאמפתית, המשלבת מקצועיות עם יחס אישי למטופליה. היא חברה באיגודים מקצועיים מובילים, כולל ESMO והאיגוד הישראלי לאונקולוגיה קלינית.",
  readFullBio: "קרא את הביוגרפיה המלאה",
  yearsExperience: "30+ שנות ניסיון",
  
  // Services Section
  servicesSubtitle:
    "ד\"ר ניימן מציעה מגוון מקיף של שירותים אונקולוגיים, מאבחון ועד תכנון טיפול ארוך טווח.",
  viewAllServices: "צפה בכל השירותים",
  
  // Testimonials Section
  patientTestimonials: "עדויות מטופלים",
  testimonialsSubtitle:
    "קרא מה המטופלים שלנו אומרים על החוויה שלהם עם ד\"ר ויקטוריה ניימן.",
  
  // Appointment Section
  scheduleAppointment: "קבע תור",
  appointmentText:
    "קח את הצעד הראשון לקראת טיפול אישי בסרטן על ידי קביעת פגישה עם ד\"ר ויקטוריה ניימן. הצוות שלנו מוכן לעזור ולספק את התמיכה שאתה צריך לאורך כל המסע הזה.",
  officeHours: "שעות פעילות",
  bookOnline: "הזמן אונליין",
  orCallDirectly: "או התקשר ישירות",
  clinicLocation: "מיקום הקליניקה",
  easyAccess: "גישה נוחה",
  
  // Blog Section
  blogSectionTitle: "תובנות רפואיות אחרונות",
  blogSectionSubtitle:
    "הישאר מעודכן עם המחקרים האחרונים, אפשרויות הטיפול ותובנות בריאותיות מד\"ר ויקטוריה ניימן.",
  viewAllPosts: "צפה בכל הפוסטים",
  
  // News Section
  inTheNews: "בחדשות",
  newsSubtitle:
    "תרומותיה של ד\"ר ויקטוריה ניימן למחקר אונקולוגי וטיפול במטופלים מופיעות בפרסומים רפואיים ובאמצעי התקשורת.",
  readOriginal: "קרא את המאמר המקורי",
  
  adminLogin: "כניסת מנהל",
  
  // Services page
  servicesHeroTitle: "השירותים שלנו",
  servicesHeroSubtitle:
    "ד\"ר ויקטוריה ניימן מציעה שירותים אונקולוגיים מקיפים עם דגש על טיפול אישי וטיפול חומל.",
  
  // CTA Section
  readyForNextStep: "מוכן לשלב הבא?",
  scheduleCTA:
    "קבע פגישה עם ד\"ר ויקטוריה ניימן לדון במצבך ולבחון את אפשרויות הטיפול הטובות ביותר עבור הצרכים הספציפיים שלך.",
  
  // Appointment Page
  scheduleAnAppointment: "קבע תור",
  appointmentDescription:
    "בקש תור עם ד\"ר ויקטוריה ניימן. ניצור איתך קשר בקרוב לאשר את מועד התור שלך.",
  requestAnAppointment: "בקשת תור",
  
  // Appointment Form
  fullName: "שם מלא",
  phoneNumber: "מספר טלפון",
  selectDate: "בחר תאריך",
  selectTime: "בחר שעה",
  reasonForVisit: "סיבת הביקור",
  selectReason: "בחר סיבה",
  additionalInformation: "מידע נוסף (אופציונלי)",
  additionalInfoPlaceholder:
    "אנא שתף מידע נוסף על מצבך או חששות ספציפיים.",
  submitRequest: "שלח בקשה",
  submitting: "שולח...",
  
  // Office Hours and Contact Info
  contactInformation: "פרטי התקשרות",
  mondayThursday: "ראשון - חמישי",
  friday: "שישי",
  officeHoursSchedule: "ראשון-חמישי: 9:00-17:00 ",
  
  // Form placeholders
  namePlaceholder: "יוחנן כהן",
  emailPlaceholder: "your@email.com",
  phonePlaceholder: "+972 (55) 123-4567",
  
  // Appointment Reasons
  initialConsultation: "התייעצות ראשונית",
  followUp: "ביקור מעקב",
  treatmentDiscussion: "דיון בטיפול",
  secondOpinion: "חוות דעת שנייה",
  testResultsReview: "סקירת תוצאות בדיקה",
  other: "אחר",
  
  skipToContent: "דלג לתוכן הראשי",
  
  // Service titles and descriptions
  cancerDiagnosis: "אבחון סרטן",
  cancerDiagnosisDesc:
    "שירותי אבחון מקיפים כולל דימות מתקדם, ביופסיות ובדיקות גנטיות לקביעת טבעו ומצבו המדויק של הסרטן שלך.",
  personalizedTreatment: "תוכניות טיפול אישיות",
  personalizedTreatmentDesc:
    "אסטרטגיות טיפול מותאמות שנוצרו במיוחד עבור מצבך, תוך התחשבות בסוג הסרטן שלך, מצבך הגנטי, ובריאותך האישית.",
  chemotherapy: "כימותרפיה",
  chemotherapyDesc:
    "מתן וניהול פרוטוקולי כימותרפיה עם מעקב צמוד וטיפול תומך להקטנת תופעות לוואי ולהגברת היעילות.",
  immunotherapy: "אימונותרפיה",
  immunotherapyDesc:
    "טיפולי אימונותרפיה מתקדמים שמגייסים את מערכת החיסון שלך להילחם בסרטן, עם מומחיות מיוחדת בפרוטוקולים החדישים ביותר.",
  targetedTherapy: "טיפול ממוקד",
  targetedTherapyDesc:
    "גישות רפואה מדויקת שמטרתן מוטציות גנטיות או חלבונים ספציפיים המעורבים בצמיחה והתפשטות הסרטן שלך.",
  survivorshipCare: "טיפול בהישרדות",
  survivorshipCareDesc:
    "טיפול מעקב ארוך טווח ותכנון בריאות לחולי סרטן, המתייחס להיבטים הפיזיים והפסיכולוגיים של החיים לאחר הסרטן.",
  
  // Research Section
  selectedPublications: "פרסומים נבחרים",
  researchInterests: "תחומי מחקר",
  publication1:
    'Neiman V, et al. (2022) "יעילות ורעילות של הקרנה היפופרקציונלית בחולי סרטן השד." סוגיות אונקולוגיות נוכחיות.',
  publication2:
    'Neiman V, et al. (2022) "ניסיון ממשי עם אנתרציקלינים וטקסנים במינון גבוה או במינון צפוף לחולי סרטן שד שלילי משולש." סוגיות אונקולוגיות נוכחיות.',
  publication3:
    'Neiman V, et al. (2021) "תוצאות חולי סרטן שד שלילי משולש שטופלו בבווציזומאב פליאטיבי." האונקולוג.',
  publication4:
    'Neiman V, et al. (2020) "יעילות ורעילות של דוקסורוביצין וציקלופוספמיד במינון צפוף (ddAC) בחולי סרטן השד: ניסיון של מרכז יחיד." סרטן השד הקליני.',
  publication5:
    'Neiman V, et al. (2019) "יעילות ורעילות של חוסמי קולטן לאנגיוטנסין II בהגדרה משנית לחולי סרטן השד: סקירה שיטתית." כתב העת לאונקולוגיה קלינית.',
  
  personalizedCancer: "טיפול אישי בסרטן",
  personalizedCancerDesc:
    "פיתוח גישות טיפול מותאמות אישית על בסיס פרופיל גנטי ומולקולרי של גידולים.",
  immunotherapyOptimization: "אופטימיזציה של אימונותרפיה",
  immunotherapyOptimizationDesc:
    "שיפור היעילות והפחתת תופעות לוואי של אימונותרפיה בסוגי סרטן ונים.",
  cancerInElderly: "סרטן בחולים קשישים",
  cancerInElderlyDesc:
    "גישות מיוחדות לטיפול בסרטן בחולים גריאטריים, באיזון בין יעילות ואיכות חיים.",
  combinationTherapy: "פרוטוקולים של טיפול משולב",
  combinationTherapyDesc:
    "חקר השפעות הסינרגיה של שילוב של גישות טיפול שונות לשיפור התוצאות.",
  
  // Accessibility Widget
  accessibilityOptions: "אפשרויות נגישות",
  fontSize: "גודל גופן",
  brightness: "בהירות",
  highContrast: "ניגודיות גבוהה",
  on: "פועל",
  off: "כבוי",
  resetAll: "אפס הכל",
  adjustFontSize: "כוונן גודל גופן",
  adjustBrightness: "כוונן בהירות מסך",
  
  // Treatment Process Section
  treatmentProcessTitle: "תהליך הטיפול שלנו",
  treatmentProcessSubtitle:
    "ד\"ר ניימן עוקבת אחר גישה מובנית כדי להבטיח טיפול מקיף לכל מטופל",
  initialConsultationStep: "התייעצות ראשונית",
  initialConsultationDesc:
    "סקירה מעמיקה של ההיסטוריה הרפואית שלך, הסימפטומים והחששות שלך כדי לקבוע הבנה בסיסית של מצבך.",
  comprehensiveDiagnosisStep: "אבחון מקיף",
  comprehensiveDiagnosisDesc:
    "פרוצדורות אבחון מתקדמות כולל דימות, בדיקות מעבדה וביופסיות כדי לזהות בדיוק את סוג הסרטן ומצבו.",
  personalizedTreatmentPlanningStep: "תכנון טיפול אישי",
  personalizedTreatmentPlanningDesc:
    "פיתוח אסטרטגיית טיפול אישית המתחשבת בפרופיל הסרטן הספציפי שלך, בריאותך הכללית והעדפותיך האישיות.",
  treatmentImplementationStep: "יישום הטיפול",
  treatmentImplementationDesc:
    "מתן זהיר של טיפולים נבחרים עם מעקב והתקנות קבועות לפי הצורך.",
  followUpCareStep: "טיפול במעקב",
  followUpCareDesc:
    "הערכות מתמשכות למעקב אחר התקדמותך, ניהול תופעות לוואי וביצוע שינויים נחוצים בתוכנית הטיפול שלך.",
  survivorshipPlanningStep: "תכנון הישרדות",
  survivorshipPlanningDesc:
    "תכנון טיפול ארוך טווח המתמקד במניעת הישנות, מעקב אחר השפעות מאוחרות של הטיפול ותמיכה בחזרתך לבריאות.",
  
  // Patient Stories
  patientStoriesTitle: "סיפורי מטופלים",
  patientStoriesDescription:
    "מטופלים משתפים את החווויות והמסעות שלהם עם ד\"ר ניימן והטיפולים שקיבלו.",
  featuredStories: "סיפורים מובחרים",
  featuredStoriesDescription:
    "סיפורים מיוחדים המדגישים את הגישה המקיפה והאישית של ד\"ר ניימן לטיפול בסרטן.",
  readFullStory: "קרא את הסיפור המלא",
  watchVideo: "צפה בוידאו",
  treatmentJourney: "מסע הטיפול",
  patientStory: "סיפור מטופל",
  shareStory: "שתף את הסיפור שלך",
  fullStory: "הסיפור המלא",
  videoTestimonial: "עדות וידאו",
  
  // Appointment management translations
  appointmentManagement: "ניהול תורים",
  editAppointment: "ערוך תור",
  deleteAppointment: "מחק תור",
  confirmDeleteAppointment: "האם אתה בטוח שברצונך למחוק את התור הזה?",
  appointmentUpdated: "התור עודכן בהצלחה",
  appointmentDeleted: "התור נמחק בהצלחה",
  noAppointments: "לא נקבעו תורים עדיין",
  
  // Video management translations
  videoManagement: "ניהול וידאו",
  addVideo: "הוסף וידאו",
  editVideo: "ערוך וידאו",
  deleteVideo: "מחק וידאו",
  confirmDeleteVideo: "האם אתה בטוח שברצונך למחוק את הוידאו הזה?",
  videoAdded: "וידאו נוסף בהצלחה",
  videoUpdated: "וידאו עודכן בהצלחה",
  videoDeleted: "וידאו נמחק בהצלחה",
  
  // Admin general
  viewAll: "צפה בהכל",
  scheduleNew: "קבע חדש",
  status: "סטטוס",
  actions: "פעולות",
  patient: "מטופל",
  dateTime: "תאריך ושעה",
  
  // WhatsApp QR Code
  whatsappQR: 'סרוק לשיחה בווטסאפ',
  openWhatsApp: 'פתח צ\'אט בווטסאפ',

  // Biography Section
  professionalBiography: "ביוגרפיה מקצועית",
  biographyText1: "ד\"ר ויקטוריה ניימן היא מומחית מובילה באונקולוגיה קלינית, רפואה פנימית ורדיותרפיה, עם ניסיון של למעלה מ-30 שנה. היא מנהלת את מחלקת האשפוז האונקולוגי במרכז דוידוף לסרטן, חלק מהמרכז הרפואי רבין (בילינסון).",
  biographyText2: "תחומי ההתמחות שלה כוללים רפואה פנימית, אונקולוגיה קלינית ורדיותרפיה, עם התמקדות מיוחדת בגידולים אורו-אונקולוגיים וסרטן השד. היא מטפלת במגוון רחב של מחלות, כולל סרטן הכליה, הערמונית, שלפוחית השתן והאשכים.",
  biographyText3: "ד\"ר ניימן סיימה את לימודי הרפואה באוניברסיטה בברית המועצות, והתמחתה ברפואה פנימית, אונקולוגיה קלינית ורדיותרפיה במרכז הרפואי רבין. היא מרצה בבית הספר לרפואה ע\"ש סאקלר באוניברסיטת תל אביב ובבית הספר לאחיות.",
  biographyText4: "היא פעילה במחקרים קליניים רבים, כולל מחקרים בינלאומיים בנושאי סרטן השד, הכליה, מערכת השתן והערמונית. מחקריה תורמים לקידום הטיפול האונקולוגי ולהבנת המחלה.",
  biographyText5: "ד\"ר ניימן חברה באיגודים מקצועיים מובילים, כולל האיגוד לאונקולוגיה קלינית ורדיותרפיה, האיגוד הישראלי לרפואה פנימית, איגוד האורולוגים הישראלי והחברה האירופית לאונקולוגיה רפואית (ESMO).",
  biographyText6: "מטופליה מציינים את מקצועיותה, האנושיות והזמינות הרבה שלה.",
  biographyText7: "ד\"ר ניימן נחשבת לדמות מרכזית בתחום האונקולוגיה בישראל, ומשלבת ידע קליני עמוק עם גישה אנושית ואמפתית. היא מובילה צוותים רפואיים ומחקריים, ומשקיעה רבות בהכשרת הדור הבא של הרופאים.",
  biographyText8: "בנוסף, היא משתתפת בכנסים מקצועיים, מעבירה הרצאות ומפרסמת מאמרים בתחום התמחותה. היא שואפת להעניק טיפול רפואי ברמה הגבוהה ביותר, תוך מתן יחס אישי ותמיכה למטופליה.",
  biographyText9: "ד\"ר ניימן מדברת עברית, אנגלית ורוסית, ומציעה שירותים רפואיים למגוון רחב של מטופלים.",
  biographyText10: "גישתה לטיפול במטופלים משלבת מומחיות רפואית מתקדמת עם חמלה עמוקה, תוך הבטחת טיפול מותאם אישית לצרכים הספציפיים של כל מטופל.",
  
  // Contact page translations
  contactDescription: "יש לך שאלות או צורך ליצור קשר עם ד\"ר ויקטוריה ניימן? אנחנו כאן לעזור.",
  sendUsMessage: "שלח לנו הודעה",
  subject: "נושא",
  subjectPlaceHolder: "איך נוכל לעזור לך?",
  messagePlaceHolder: "אנא ספק פרטים לגבי שאלתך",
  submitMessage: "שלח הודעה",
  officeAddress: "כתובת",
  officePhone: "טלפון",
  officeEmail: "דוא\"ל",
  messageSent: "הודעתך נשלחה! נחזור אליך בהקדם.",
  errorSending: "שגיאה בשליחת ההודעה",
  enterValidEmail: "אנא הכנס כתובת דוא\"ל תקינה.",
  enterValidPhone: "אנא הכנס מספר טלפון תקין.",
  nameRequired: "נדרש למלא שם",
  subjectRequired: "נדרש למלא נושא",
  messageRequired: "נדרש למלא הודעה",
  frequently: "שאלות נפוצות",
  appointmentQuestion: "כיצד ניתן לקבוע תור?",
  appointmentAnswer: "ניתן לקבוע תור על ידי התקשרות למשרד, שימוש בטופס הזמנת תור באינטרנט, או שליחת דוא\"ל.",
  referralQuestion: "האם אני זקוק להפניה?",
  referralAnswer: "למרות שהפניה מרופא המשפחה מועילה, היא לא תמיד נדרשת. אנא צור קשר עם המשרד שלנו כדי לדון במצב הספציפי שלך.",
  insuranceQuestion: "אילו תוכניות ביטוח אתם מקבלים?",
  insuranceAnswer: "אנו עובדים עם רוב ספקי הביטוח הרפואי הגדולים. אנא צור קשר עם המשרד שלנו למידע ספציפי על כיסוי הביטוח שלך.",
  aboutDoctorHeader: `על ד"ר ויקטוריה ניימן`,
  melanoma: "מלנומה",
  prostate: "סרטן הערמונית",
  
  // Contact Management
  contactManagement: "ניהול פרטי יצירת קשר",
  editContactInfo: "עריכת פרטי יצירת קשר",
  addContactInfo: "הוספת פרטי יצירת קשר",
  typeLabel: "סוג",
  valueLabel: "ערך",
  orderLabel: "סדר",
  iconLabel: "אייקון",
  hours: "שעות פעילות",
  saveChanges: "שמור שינויים",
  error: "שגיאה",
  type: "סוג",
  value: "ערך",
  section: "מדור",
  selectSection: "בחר מדור",
  order: "סדר",
  link: "קישור",
  icon: "אייקון",
  title: "כותרת",
  content: "תוכן",
  saving: "שומר...",
  pleaseFillInAllRequiredFields: "אנא מלא את כל השדות הנדרשים",
  selectType: "בחר סוג",
  edit: "ערוך",
  delete: "מחק",
};
